import React from 'react';

// Typy modułu PV pochodzą WYŁĄCZNIE z API: preferuj listę `types` (drugi typ
// wylicza backend — np. ["Bifacial","Full Black"]); gdy brak lub pusta -> fallback
// na pojedyncze `type` (kompatybilność wsteczna). Front NIE wnioskuje ani nie skleja
// typów z nazwy produktu.
export const moduleTypes = (m) => {
  if (m && Array.isArray(m.types) && m.types.length) return m.types.filter(Boolean);
  return m && m.type ? [m.type] : [];
};

const CHIP = 'inline-flex items-center rounded-md bg-blue-50 text-blue-700 text-xs font-semibold px-2 py-0.5';

// Renderuje każdy typ jako osobny chip (nie sklejony string). Zawija się na wąskim
// ekranie (flex-wrap). Zwraca null gdy brak typów.
const TypeChips = ({ types, type, className = '' }) => {
  const list = moduleTypes({ types, type });
  if (!list.length) return null;
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`}>
      {list.map((t) => <span key={t} className={CHIP}>{t}</span>)}
    </div>
  );
};

export default TypeChips;
